import React from "react";
import { ACTIONS } from "../state/contexts/quizState";
import { useQuiz } from "../services/hooks/useQuiz";

export default React.memo(function QuizQ11({ isActive }) {
  const { setAnswer, quizResponses } = useQuiz();

  const { favoriteTools } = quizResponses;

  const onAnswer = (answer) => {
    if (favoriteTools.indexOf(answer) !== -1) {
      removeFavoriteTools(answer);
    } else {
      setFavoriteTools(answer);
    }
  };

  const setFavoriteTools = (answer) => {
    setAnswer(ACTIONS.SET_FAVORITE_TOOL, {
      favoriteTool: answer,
    });
  };

  const removeFavoriteTools = (answer) => {
    setAnswer(ACTIONS.REMOVE_FAVORITE_TOOL, {
      favoriteTool: answer,
    });
  };

  const options = [
    {
      title: "Makeup brushes",
    },
    {
      title: "Lashes",
    },
    {
      title: "Makeup wipes",
    },
    {
      title: "Brush cleaner",
    },
    {
      title: "Tweezers",
    },
  ];

  const listItems = options.map(({ title }) => (
    <div
      key={title}
      className="quiz-radio-option"
      onClick={() => {
        onAnswer(title);
      }}
    >
      <div className="custom-control custom-checkbox float-left">
        <input
          type="checkbox"
          id={title}
          name="favoriteTools"
          value={title}
          className="custom-control-input"
          checked={favoriteTools.indexOf(title) !== -1}
          onChange={(e) => {
            if (e.target.checked) {
              removeFavoriteTools(e.target.value);
            } else {
              setFavoriteTools(e.target.value);
            }
          }}
        />
        <label className="custom-control-label" htmlFor={title}></label>
      </div>
      <div className="ml-8 quiz-radio-content">
        <p className="font-size-h6">{title}</p>
      </div>
    </div>
  ));

  if (!isActive) {
    return null;
  }

  return (
    <React.Fragment>
      <h4 className="mb-8">
        Which of these beauty tools would you most like to receive?
      </h4>
      <p className="text-muted">Select all that apply</p>

      <div className="quiz-radio-options">{listItems}</div>
    </React.Fragment>
  );
});
